import { HELP_RESOURCES_ARTICLES } from '@/constants';
import { Crisp } from 'crisp-sdk-web';
import i18next from 'i18next';
import posthog from 'posthog-js';

export const toggleChat = (force?: boolean, view: string = 'chat') => {
    if (typeof force === 'undefined') force = !Crisp.chat.isChatOpened();

    if (!force) {
        Crisp.chat.close();
        Crisp.chat.hide();
    } else {
        Crisp.chat.show();
        Crisp.chat.open();

        // Update PostHog session ID when chat is opened to ensure it's current
        const currentSessionId = posthog.get_session_id();
        if (currentSessionId) {
            Crisp.session.setData({
                posthogSessionId: currentSessionId,
            });
        }
    }

    if (typeof view !== 'undefined') {
        if (view === 'helpdesk') {
            Crisp.chat.setHelpdeskView();
        }
    }
};

export const openHelpdeskArticle = (constant: keyof typeof HELP_RESOURCES_ARTICLES) => {
    if (typeof HELP_RESOURCES_ARTICLES[constant] === 'undefined') return;

    const article = HELP_RESOURCES_ARTICLES[constant] as Record<string, string>;

    let locale = i18next.language.split('-')[0];
    if (typeof article[locale] === 'undefined') {
        locale = 'en';
    }

    Crisp.chat.openHelpdeskArticle(locale, article[locale]);
};
